export const DR_LOCAL_STORAGE_KEYS = {
  REDIRECT_URL: 'redirect_url',
};
